import useDebounceInput from 'customHooks/useDebounceInput'
import {
  setCheckAll,
  setUncheckAll,
  fetchGetSOProductDirect,
} from 'features/SupplyOrder/redux/outboundSOAddProductDirect'
import { useMemo } from 'react'
import { shallowEqual, useAppDispatch, useAppSelector } from 'store'

const useTable = () => {
  const dispatch = useAppDispatch()

  const { query, checkedIds, createSO, data, constants } = useAppSelector(
    (state) => state.outboundSOAddProductDirect,
    shallowEqual,
  )

  const currentPageIds = useMemo(() => data.map((item) => item.productUniqueKey), [data])

  const checkedCount = currentPageIds.filter((id) => checkedIds.includes(id)).length
  const isAllChecked = checkedCount === currentPageIds.length && currentPageIds.length > 0
  const isIndeterminate = checkedCount > 0 && checkedCount < currentPageIds.length

  const soType = createSO?.soType.toLowerCase()

  const locationSelected = {
    origin: createSO?.origin?.location_name || null,
    destination: createSO?.destination?.location_name || null,
  }

  const [search, handleSearch] = useDebounceInput({
    onChange: (value) => {
      dispatch(
        fetchGetSOProductDirect({
          productName: value,
          pageIndex: 1,
        }),
      )
    },
  })

  const handleChangeStatusNote = (val: (typeof constants.statusNotes)[number]) => {
    dispatch(
      fetchGetSOProductDirect({
        statusNoteId: val.id,
        pageIndex: 1,
      }),
    )
  }

  const handleChangeProductType = (val: (typeof constants.productType)[number][]) => {
    const productTypeIds = val.map((type) => type.product_type_id).join(',')
    dispatch(
      fetchGetSOProductDirect({
        productTypeIds,
        pageIndex: 1,
      }),
    )
  }

  const handleChangeCheckbox = (checked: boolean) => {
    if (checked) {
      dispatch(setCheckAll(currentPageIds))
    } else {
      dispatch(setUncheckAll(currentPageIds))
    }
  }

  const handleChangePage = (page: number) => {
    dispatch(
      fetchGetSOProductDirect({
        pageIndex: page,
      }),
    )
  }

  const handleChangeRowsPerPage = (rowsPerPage: number) => {
    dispatch(
      fetchGetSOProductDirect({
        pageIndex: 1,
        pageSize: rowsPerPage,
      }),
    )
  }

  return {
    isAllChecked,
    isIndeterminate,
    checkedIds,
    query,
    locationSelected,
    soType,
    data,
    constants,
    search,
    handleSearch,
    handleChangeStatusNote,
    handleChangeProductType,
    handleChangeCheckbox,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}

export default useTable
